import {
  UPDATE_ALL_PROVIDER_LIST_DETAILS,
  UPDATE_ALL_PROVIDER_LIST_DETAILS_FAILURE,
  UPDATE_ALL_PROVIDER_LIST_DETAILS_SUCCESS,
} from './action';

const initialState = {
  loading: false,
  data: [],
  error: '',
};

const updateAllProviderListDetailsReducer = (state = initialState, action) => {
  switch (action.type) {
    case UPDATE_ALL_PROVIDER_LIST_DETAILS:
      return { ...state, loading: true };
    case UPDATE_ALL_PROVIDER_LIST_DETAILS_SUCCESS:
      return { ...state, loading: false, data: action.payload, error: '' };
    case UPDATE_ALL_PROVIDER_LIST_DETAILS_FAILURE:
      return { ...state, loading: false, data: [], error: action.payload };
    default:
      return state;
  }
};

export default updateAllProviderListDetailsReducer;
